import { Alert, styled } from "@mui/material";
import { useContext } from "react";
import DialogContext from "src/pages/App/AppSettings/Customization/context";

import Context from "../../context";

// ----------------------------------------------------------------------

const StyledAlert = styled(Alert)<{
	lightError: string;
	darkError: string;
	type: string;
	mainError: string;
}>(({ darkError, lightError, type, mainError }) => {
	return {
		backgroundColor: type !== "DARK" ? lightError : darkError,
		color: type !== "DARK" ? darkError : lightError,
		".MuiAlert-icon": {
			color: type !== "DARK" ? mainError : lightError
		}
	};
});

type Props = {
	errorMessage: string;
};

export const ErrorResult = ({ errorMessage }: Props) => {
	const { values } = useContext(Context);
	const { state } = useContext(DialogContext);
	return (
		<StyledAlert
			severity='error'
			sx={{ mb: 2, mt: 2 }}
			lightError={values.lightError}
			darkError={values.darkError}
			mainError={values.mainError}
			type={state.type}
		>
			{errorMessage}
		</StyledAlert>
	);
};

export default ErrorResult;
